<template>
  <div class="prizes-2021-promo">
    <div class="prizes-2021-promo__info">
      <img
        src="@/assets/img/prizes/2021/promoaction/ozon.png"
        alt="Ozon"
        class="prizes-2021-promo__logo"
      />
      <div class="prizes-2021-promo__description">
        Покупай продукцию hyperx<br />
        <span class="text-orange">со скидкой 20%</span>
      </div>
      <div class="prizes-2021-promo__actions">
        <Prizes2021Promocode />
        <AppBtn
          href="http://bit.ly/3ciB0kl"
          class="prizes-2021-promo__btn"
          color="yellow-grad"
          border="bottom"
          target="_blank"
          rel="noopener"
        >
          Перейти
        </AppBtn>
      </div>
      <div class="prizes-2021-promo__hint">
        код вводить при оформлении заказа
      </div>
    </div>
    <Prizes2021PromoProductList :list="productList" />
  </div>
</template>

<script>
import Prizes2021PromoProductList from "./Prizes2021PromoProductList";
import Prizes2021Promocode from "./Prizes2021Promocode";
import { productList } from "./data";

export default {
  name: "Prizes2021Promo",
  components: {
    Prizes2021PromoProductList,
    Prizes2021Promocode
  },
  computed: {
    productList() {
      return productList;
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-promo {
  line-height: normal;

  display: flex;

  margin-top: 120px;
  margin-bottom: 100px;

  &__logo {
    height: 49px;
    display: block;
    margin-bottom: 45px;
  }

  &__info {
    padding-right: 80px;
  }

  &__description {
    text-transform: uppercase;
    font-size: 35px;
    font-weight: 800;
    letter-spacing: 0.01em;
  }

  &__actions {
    display: flex;
    margin-top: 50px;
  }

  &__btn {
    height: 55px;
    width: 180px;
    flex-shrink: 0;
  }

  &__hint {
    font-size: 12px;
    color: darken(#fff, 30%);
    margin-top: 5px;
  }

  @include breakpoint("md-and-down") {
    flex-direction: column;
    margin-top: 100px;

    &__logo {
      margin: 0 auto 30px;
    }

    &__actions {
      margin: 30px auto 0;
      max-width: 500px;
    }

    &__info {
      text-align: center;
      margin-bottom: 50px;
      padding-right: 0;
    }
  }

  @include breakpoint("sm-and-down") {
    margin-top: 80px;
    &__logo {
      height: 40px;
      margin-bottom: 25px;
    }
    &__description {
      font-size: 30px;
      margin-top: 25px;
    }
    &__btn {
      height: 45px;
    }
  }

  @include breakpoint("xs-only") {
    &__description {
      font-size: 25px;
    }
    &__actions {
      flex-direction: column;
    }
    &__btn {
      margin: 0 auto;
    }
  }
}
</style>
